export const TABLE = 'TABLE'; 

export const ADDTABLE = 'ADDTABLE'; 

export const LIST_TABLE = 'LIST_TABLE'

export const TABLE_DETAILS = 'TABLE_DETAILS'

